import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { Button } from "../components/ui/button";
import { Wallet, LogOut } from "lucide-react";

import React, { useState } from "react";
import { useWallet } from "@solana/wallet-adapter-react";
import { motion } from "framer-motion";

const WalletConnect = ({ onConnect, onDisconnect }) => {
  const { connected, connecting, disconnect, wallet, publicKey, wallets, select } = useWallet();
  const [showWalletList, setShowWalletList] = useState(false);

  const handleDisconnect = async () => {
    await disconnect();
    onDisconnect?.();
  };

  const handleWalletSelect = async (walletName) => {
    try {
      select(walletName);
      setShowWalletList(false);
      onConnect?.();
    } catch (error) {
      console.error('Wallet connection error:', error);
    }
  };

  if (connected && publicKey) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex items-center gap-3"
      >
        <div className="hidden sm:flex flex-col items-end">
          <span className="text-sm font-medium text-foreground">
            {wallet?.adapter.name || "Wallet"}
          </span>
          <span className="text-xs text-muted-foreground font-mono">
            {publicKey.toString().slice(0, 4)}...
            {publicKey.toString().slice(-4)}
          </span>
        </div>
        <button
          size="sm"
          onClick={handleDisconnect}
          className="gap-2 btn main-btn mt-4"
        >
          <i className="fas fa-sign-out-alt h-4 w-4"></i>
          <span className="hidden sm:inline">Disconnect</span>
        </button>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
    >
      {showWalletList ? (
        <div className="wallet-selection-dropdown">
          <div className="d-flex flex-column gap-2 p-3 border rounded bg-dark">
            <div className="text-center mb-2">
              <small className="text-muted">Select a Solana wallet:</small>
            </div>
            {wallets.map((walletAdapter) => (
              <button
                key={walletAdapter.adapter.name}
                onClick={() => handleWalletSelect(walletAdapter.adapter.name)}
                className="btn btn-outline-light btn-sm d-flex align-items-center justify-content-start gap-2"
                disabled={connecting}
              >
                {walletAdapter.adapter.icon && (
                  <img 
                    src={walletAdapter.adapter.icon} 
                    alt={walletAdapter.adapter.name}
                    style={{ width: '20px', height: '20px' }}
                  />
                )}
                {walletAdapter.adapter.name}
              </button>
            ))}
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => setShowWalletList(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setShowWalletList(true)}
          className="btn main-btn"
          disabled={connecting}
        >
          <i className="fas fa-wallet me-2"></i>
          {connecting ? 'Connecting...' : 'Connect Solana Wallet'}
        </button>
      )}
    </motion.div>
  );
};

export default WalletConnect;
